import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './styles.scss';
import { useTranslation } from 'react-i18next';
import SearchCarWidget from "../SearchCarWidget";

const HomeContent = ({ onSubmit, params, wl, locations }) => {
  const { t, i18n } = useTranslation(); // eslint-disable-line
  const lng = i18n.language.substring(0, 2)
  const [showLocationContent, setShowLocationContent] = useState(false);

  // Utility: get location name by code
  const getLocationName = (code) => {
    if (!Array.isArray(locations)) return code;
    const loc = locations.find(l => String(l.locationCode) === String(code));
    return loc ? loc.locationName : code;
  };

  useEffect(() => {
    if (params && params?.fromLocationCode === params?.toLocationCode && params?.fromLocationCode?.match(/168|1|340/) && lng === 'he') {
      setShowLocationContent(true);
    } else {
      setShowLocationContent(false);
    }

  }, [params, lng]);

  useEffect(() => {
    // Remove any existing script with the same id before adding a new one
    const existingScript = document.getElementById('pp-widget-main');
    if (existingScript) {
      existingScript.parentNode.removeChild(existingScript);
    }
    const script = document.createElement('script');
    script.src = '/pp-widget/main.js';
    script.async = true;
    script.id = 'pp-widget-main';

    if (showLocationContent) {
      document.body.appendChild(script);
    }

    return () => {
      const scriptToRemove = document.getElementById('pp-widget-main');
      if (scriptToRemove) {
        scriptToRemove.parentNode.removeChild(scriptToRemove);
      }
    };
  }, [showLocationContent]);

  return (
    <div>
      <div className="container col-xxl-8 p-0 py-md-5">
        <div className="row no-gutters flex-lg-row-reverse align-items-center g-5 py-0 py-md-5">
          <div className="col-lg-6 px-4">
            {wl ? <img className="d-block mx-auto mb-4" src={`/${wl}.png`} alt="logo" width="300rem" /> : ''}
            {wl ? '' : 
              showLocationContent ? 
              <h1 className="display-5 fw-bold">{t(`השכרת רכב ב${getLocationName(params.fromLocationCode)}`)}</h1> :
              <h1 className="display-5 fw-bold lh-1 mb-3">{t('homepageWelcomeHeader')}</h1>
            }
            <p className="lead d-none d-sm-block">
              {t('homepageLead1')}{showLocationContent ? ` ב${getLocationName(params.fromLocationCode)}` : ''}.&nbsp;
              <b>{wl ? wl : t('brand')}</b> - {t('homepageLead2')}
            </p>
          </div>
          <div className="col-12 col-sm-8 col-lg-6 px-0 px-sm-2">
            <SearchCarWidget onSubmit={onSubmit} params={params} minimized={false} autoFocus={true} />
          </div>
        </div>
      </div>
      <div className="b-example-divider"></div>
      {showLocationContent ? (
      <>
        <div className="bg-white px-4 py-5 text-center">
          <h2 className="display-5 fw-bold">{t(`דילים להשכרת רכב ב${getLocationName(params.fromLocationCode)}`)}</h2>
          <div className="col-lg-6 mx-auto">
            <p className="lead mb-4">{t('מחירים מעודכנים לשבוע הבא')}</p>
          </div>
          <div id="offersContainer" data-items-to-show="9" data-pu-location-code={params.fromLocationCode} data-pu-location-he={getLocationName(params.fromLocationCode)}></div>
        </div>
        <div className="b-example-divider"></div>
      </>
      ) : ''}
      <div className="container col-xxl-8 px-4 py-5">
        <div className="row flex-lg-row-reverse align-items-center g-5 py-5">
          <div className="col-lg-6">
            <h2 className="display-5 fw-bold lh-1 mb-3">{t('homepageHeader2')}</h2>
            <p className="lead">{t('homepageLead3')}</p>
          </div>
          <div className="col-lg-6">
            <img src="/rental logos.jpg" width="786" height="182" className="d-block mx-lg-auto img-fluid" alt="logo" loading="lazy" />
          </div>
        </div>
      </div>
      <div className="b-example-divider"></div>
      <div className="bg-white px-4 py-5 text-center">
        <h2 className="display-5 fw-bold">{t('homepageHeader3')}</h2>
        <div className="col-lg-6 mx-auto">
          <p className="lead mb-4">{t('homepageLead4')}</p>
        </div>
        <img src={`/${t("testimonialImage")}`} width="500" height="625" className="d-block mx-auto mb-4 img-fluid" alt="testimonial" loading="lazy" />
      </div>
    </div>
  );
};

const mapStateToProps = ({ vendors, results, ui, locations }) => ({
  // dir: ui.direction,
  wl: ui.whiteLabel,
  locations: locations.data,
});

export default connect(mapStateToProps)(HomeContent);
// export default HomeContent;